module.exports = __webpack_public_path__ + "static/media/ly.050ff9b0.svg";